(function() {
  'use strict';
  
  // Ждём пока Hulk и DOM загрузятся
  function initHulkValidation() {
    const hulkContainer = document.querySelector('.hulkapps_product_options');
    if (!hulkContainer) {
      // Hulk ещё не загрузился, пробуем снова
      setTimeout(initHulkValidation, 500);
      return;
    }
    
    // Находим ВСЕ кнопки Add to Cart на странице
    const addToCartSelectors = [
      'button[name="add"]',
      'button[type="submit"][name="add"]',
      '.product-form__submit',
      '.btn-addtocart',
      '.t4s-product-form__submit',
      '[data-t4s-pr-atc-btn]',
      'form[action*="/cart/add"] button[type="submit"]'
    ];
    
    const addToCartButtons = document.querySelectorAll(addToCartSelectors.join(','));
    
    if (addToCartButtons.length === 0) {
      console.warn('[Hulk Validation] Add to Cart кнопки не найдены');
      return;
    }
    
    addToCartButtons.forEach(function(btn) {
      // Перехватываем клик в режиме CAPTURE (до того как Shopify начнёт обработку)
      btn.addEventListener('click', function(e) {
        const isValid = validateHulkOptions();
        
        if (!isValid) {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
          
          showValidationError();
          scrollToFirstError();
          
          return false;
        }
      }, true); // <-- CAPTURE phase, ключевой момент
    });
    
    // Также перехватываем submit формы (на случай Enter в input)
    const productForms = document.querySelectorAll('form[action*="/cart/add"]');
    productForms.forEach(function(form) {
      form.addEventListener('submit', function(e) {
        if (!validateHulkOptions()) {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
          showValidationError();
          scrollToFirstError();
          return false;
        }
      }, true);
    });
    
    console.log('[Hulk Validation] Инициализирована для', addToCartButtons.length, 'кнопок');
  }
  
  // Проверяем все обязательные Hulk опции
  function validateHulkOptions() {
    const hulkContainer = document.querySelector('.hulkapps_product_options');
    if (!hulkContainer) return true; // Если Hulk нет на странице — пропускаем
    
    let isValid = true;
    
    // Сбрасываем предыдущие ошибки
    hulkContainer.querySelectorAll('.hulk-validation-error').forEach(function(el) {
      el.classList.remove('hulk-validation-error');
    });
    
    // Находим все обязательные опции (у Hulk это *)
    // Проверяем visible options (не скрытые conditional logic)
    const allOptions = hulkContainer.querySelectorAll('.hulkapps_option');
    
    allOptions.forEach(function(option) {
      // Пропускаем information секции
      if (option.classList.contains('information_render')) return;
      
      // Пропускаем скрытые conditional опции
      if (option.offsetParent === null) return;
      if (option.style.display === 'none') return;
      
      // Проверяем есть ли звёздочка (required)
      const hasRequired = option.querySelector('.required, [class*="required"], .hulk-required') !== null
                        || option.innerHTML.includes('required')
                        || option.querySelector('label')?.textContent.includes('*');
      
      if (!hasRequired) return;
      
      // Проверяем заполнено ли
      const isFilled = checkOptionFilled(option);
      
      if (!isFilled) {
        isValid = false;
        option.classList.add('hulk-validation-error');
      }
    });
    
    return isValid;
  }
  
  // Проверяем заполнена ли конкретная опция
  function checkOptionFilled(option) {
    const hiddenProperty = option.querySelector('input[type="hidden"][name^="properties["]');
    if (hiddenProperty && hiddenProperty.value.trim() !== '') {
      return true;
    }

    // Radio buttons / checkboxes — хотя бы один выбран
    const radios = option.querySelectorAll('input[type="radio"]');
    if (radios.length > 0) {
      return Array.from(radios).some(function(r) { return r.checked; })
        || option.querySelector('.button_selected, .swatch_selected, .selected, .active') !== null;
    }
    
    const checkboxes = option.querySelectorAll('input[type="checkbox"]');
    if (checkboxes.length > 0 && option.classList.contains('cb_render')) {
      return Array.from(checkboxes).some(function(c) { return c.checked; });
    }
    
    // Swatch — проверяем selected класс
    if (option.classList.contains('swatch_render')) {
      return option.querySelector('.swatch_selected, .button_selected, .selected, .active, input:checked') !== null;
    }
    
    // Button render — проверяем selected
    if (option.classList.contains('button_render')) {
      return option.querySelector('.button_selected, .swatch_selected, .selected, .active, input:checked') !== null;
    }
    
    // Text input / number / textarea
    const textInputs = option.querySelectorAll('input[type="text"], input[type="number"], textarea');
    if (textInputs.length > 0) {
      return Array.from(textInputs).every(function(input) {
        return input.value.trim() !== '';
      });
    }
    
    // Select dropdown
    const selects = option.querySelectorAll('select');
    if (selects.length > 0) {
      return Array.from(selects).every(function(s) { 
        return s.value && s.value !== ''; 
      });
    }
    
    return true; // По умолчанию — считаем заполненным
  }
  
  // Показываем сообщение об ошибке
  function showValidationError() {
    // Удаляем старое сообщение если есть
    const oldError = document.getElementById('hulk-custom-error-message');
    if (oldError) oldError.remove();
    
    const errorMsg = document.createElement('div');
    errorMsg.id = 'hulk-custom-error-message';
    errorMsg.innerHTML = '⚠ Please complete all required options before adding to cart';
    errorMsg.style.cssText = `
      position: fixed;
      top: 20px;
      left: 50%;
      transform: translateX(-50%);
      background: #c04848;
      color: white;
      padding: 14px 24px;
      border-radius: 8px;
      font-weight: 600;
      font-size: 14px;
      box-shadow: 0 4px 16px rgba(0,0,0,0.2);
      z-index: 99999;
      animation: hulkErrorSlide 0.3s ease-out;
    `;
    
    document.body.appendChild(errorMsg);
    
    setTimeout(function() {
      errorMsg.style.opacity = '0';
      errorMsg.style.transition = 'opacity 0.3s';
      setTimeout(function() { errorMsg.remove(); }, 300);
    }, 4000);
  }
  
  // Скроллим к первой незаполненной опции
  function scrollToFirstError() {
    const firstError = document.querySelector('.hulk-validation-error');
    if (firstError) {
      const offset = 100;
      const targetY = firstError.getBoundingClientRect().top + window.pageYOffset - offset;
      window.scrollTo({ top: targetY, behavior: 'smooth' });
    }
  }
  
  // Запускаем
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHulkValidation);
  } else {
    initHulkValidation();
  }
})();
